import React from 'react';
import _ from 'lodash';
import moment from 'moment';


export default class BuilderForm {
	constructor(app){
		this.app = app;
		this.reset();
	}

	reset(){
		this.experiment = {
			status: '',
			name: '',
			description: '',
			time: '',
			rules:[],
		};
	}

	async load({experimentId}){
		this.app.startLoadingForm(this);
		try{
			let authentication = this.app.localStorage('authentication');
			this.app.mediaManager.setupS3({experimentId, researcherId:authentication.IdentityId});

			let loadMediaPromise = this.app.mediaManager.getExperimentAssets();
			let experiment = await this.app.http.getExperiment({experimentId});
			await loadMediaPromise;

			experiment = {
				...this.app.EXPERIMENT_DEFAULTS,
				...experiment
			};

			if(_.isEmpty(experiment.definition)){
				experiment.definition = {screens: {id:'Experiment', isGroup: true, children:[{id:'Intro', elements:[]}]}};
			}

			experiment.definition.dataSets = experiment.definition.dataSets || [];
			experiment.definition.mediaSet = experiment.definition.mediaSet || {};

			experiment.definition.width = experiment.definition.width || 600;
			experiment.definition.height = experiment.definition.height || 500;

			// Needed to load the assets for the participant.
			experiment.definition.researcherId = authentication.IdentityId;
			this.app.experiment.data = experiment.definition;
			this.app.experiment.details = experiment;
			if(this.app.experiment.data.screens && this.app.experiment.data.screens.children && this.app.experiment.data.screens.children.length){
				this.app.experiment.selectFirstScreen();
			}

			this.app.experiment.lastSaved = JSON.stringify(this.app.experiment.details);

			this.app.stopLoadingForm(this);
		}catch(e){
			console.log(e);
			if(this.app.user){
				this.app.goToMessagePage({
					title: 'Unable to load experiment',
					body: (<div>There was an error loading the experiment. Please try again.</div>)
				});
				this.app.stopLoadingForm(this, e);
			}else{
				throw e;
			}
			
		}
	}

	async submit(){
		let experimentEntity = this.app.experiment.details;
		experimentEntity.name = experimentEntity.name || 'Untitled Experiment';

		if(experimentEntity.status === 'active' && !experimentEntity.start){
			experimentEntity.start = moment().format('YYYY-MM-DD');
		}


		if(experimentEntity.status === 'active'){
			if(+experimentEntity.participantCap < 1 ){
				this.app.showFlashMessage({color:'red', label:'You must set a participant cap before you can save an activated experiment.'});
				return;
			}
			if(+experimentEntity.time < 1){
				this.app.showFlashMessage({color:'red', label:'You must set an estimated time before you can save an activated experiment.'});
				return;
			}
		}

		let tempJSON = JSON.stringify(experimentEntity);

		if(this.app.experiment.lastSavedErrorJSON === tempJSON){
			return;
		}


		this.app.startLoadingForm(this.app.experiment);

		
		try{
			await this.app.http.updateExperiment({experiment:experimentEntity});
			this.app.experiment.lastSaved = tempJSON;
			this.app.experiment.lastSavedErrorJSON = null;
			//this.app.showFlashMessage({label: 'Success! Your experiment has been saved.', autoClose:3});
			this.app.stopLoadingForm(this.app.experiment);
			
		}catch(e){
			console.log(e);
			this.app.experiment.lastSavedErrorJSON = tempJSON;
			this.app.showFlashMessage({label: 'Error! Failed to save. Please try again.', color:'red'});
			this.app.stopLoadingForm(this.app.experiment, e);
		}
	}
}



// WEBPACK FOOTER //
// ./src/models/BuilderForm.js